import { render, staticRenderFns } from "./OvervagningTermsheet.vue?vue&type=template&id=75499560&"
import script from "./OvervagningTermsheet.vue?vue&type=script&lang=js&"
export * from "./OvervagningTermsheet.vue?vue&type=script&lang=js&"
import style0 from "./OvervagningTermsheet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports